import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row, DropdownButton, MenuItem, HelpBlock } from 'react-bootstrap';
import { Input, FormActions, DateTimeInput, Select } from '../../common/components/formControls';
import { withTranslation } from 'react-i18next';
import utils from '../../common/services/utils';
import CentersDropdownList from '../centers/DropdownList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, onSubmit, onReset, initialize, loading, instalmentPaymentTypes, paymentStatusTypes, t }) => {
	const handleReset = () => {
		initialize({});
		onReset();
	};
	const menuItemInnerStyle = { display: 'block', padding: '10px 20px' };

	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={6}>
							<Field name='paymentHistoryId' component={Input} type='text' label={t('PaymentHistory_Id')} />
						</Col>
						<Col sm={6}>
							<Field name='transaction' component={Input} type='text' label={t('InstalmentPayment_Transaction')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Select name='type' label={t('InstalmentPayment_Type')} data={instalmentPaymentTypes} />
						</Col>
						<Col sm={6}>
							<Select name='status' label={t('PaymentHistory_Status')} data={paymentStatusTypes} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<CentersDropdownList render='field' name='centerId' label={t('PaymentHistory_Center')} />
						</Col>
						<Col sm={3}>
							<Field name='paymentDateFrom' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodFrom()} label={t('PaymentHistory_PaymentDate')} placeholder={t('Common_From')} />
						</Col>
						<Col sm={3}>
							<Field name='paymentDateTo' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodTo()} placeholder={t('Common_To')} label='&nbsp;' />
						</Col>
					</Row>
					<Row>
						<Col sm={3}>
							<Field name='chargeDateFrom' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodFrom()} label={t('InstalmentPayment_ChargeDate')} placeholder={t('Common_From')} />
						</Col>
						<Col sm={3}>
							<Field name='chargeDateTo' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodTo()} placeholder={t('Common_To')} label='&nbsp;' />
						</Col>
					</Row>
					<FormActions>
						<Button onClick={handleSubmit(values => onSubmit({ ...values }))} disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<DropdownButton title={<span>{t('Common_Export')} <FontAwesomeIcon icon={faChevronDown} /></span>} noCaret disabled={loading} bsStyle='warning'>
							<MenuItem key='Excel' eventKey='Excel' onSelect={handleSubmit(values => onSubmit({ ...values }, 'Excel'))}>
								<span style={menuItemInnerStyle} >{t('Common_ExportToExcel')}</span>
							</MenuItem>
							<MenuItem key='Xero' eventKey='Xero' onSelect={handleSubmit(values => onSubmit({ ...values }, 'Xero'))} >
								<span style={menuItemInnerStyle} >{t('Common_ExportToXeroCSV')}</span>
							</MenuItem>
						</DropdownButton>
						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
					<HelpBlock>{t('Common_ExportHelpText')}</HelpBlock>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'instalmentPaymentsFilter' })(withTranslation()(Filter));